import React from "react";
import PropTypes from "prop-types";
import {
    Drawer,
    Row,
    Col,
    Descriptions,
    Card,
    Empty,
    Spin,
    message,
    Form,
    Button
} from "antd";
import { OrderedMap } from "immutable";
import { INPUT_TYPES } from "constants";
import { fieldGenerator, getValidateStatus } from "utilities/form";
import { CompanyService } from "../../../../services";
import moment from "moment";
const FormItem = Form.Item;


class AddDeviationModal extends React.Component {
    state = {
        meetingData: [],
        addDeviationLoader: false
    };

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);


    formFields = (vpSalesManagers , salesPerson) =>  new OrderedMap({
        deviation_raised_for: {
            key: "deviation_raised_for",
            label: "Deviation Raised for",
            dataIndex: "deviation_raised_for",
            type: INPUT_TYPES.TEXT,
            className: "form-field mr-10 mb-0",
            disabled: true,
        },
        deviation_type: {
            key: "deviation_type",
            label: "Deviation Type",
            dataIndex: "anchor",
            type: INPUT_TYPES.SELECT,
            className: "form-field mr-10 mb-0",
            options: this.props.all_enums.getIn(["data","deviation_types"]),
            // options: [
            //     {
            //         label: "Rotation Approval",
            //         value: 1
            //     },
            //     {
            //         label: "SBD Approval",
            //         value: 2
            //     },
            //     {
            //         label: "Margin Release",
            //         value: 3
            //     },
            //     {
            //         label: "Program to retailer level",
            //         value: 4
            //     },
            //     {
            //         label: "OTP consent not required",
            //         value: 5
            //     },
            //     {
            //         label: "Margin Adjustment",
            //         value: 6
            //     },
            //     {
            //         label: "Recredit",
            //         value: 7
            //     },
            //     {
            //         label: "Cross sell",
            //         value: 8
            //     },
            //     {
            //         label: "Risk Share",
            //         value: 9
            //     }
            // ],
            rules: [
                {
                    required: true,
                    message: "Field is Required"
                },
            ]
        },
        deviation_reason: {
            key: "deviation_reason",
            label: "Reason for the deviation",
            dataIndex: "deviation_reason",
            className: "form-field mr-10 mb-0",
            type: INPUT_TYPES.TEXT,
            labelProp: "name",
            rules: [
                {
                    required: true,
                    message: "Field is Required"
                },
            ]
        },
        commitment: {
            key: "commitment",
            label: "Underlying Commitment",
            dataIndex: "commitment",
            type: INPUT_TYPES.SELECT,
            className: "form-field mr-10 mb-0",
            options: this.props.all_enums.getIn(["data","underlying_commitment_type"]),
            // options: [
            //     {
            //         label: "Rotation Approval",
            //         value: 1
            //     },
            //     {
            //         label: "SBD Approval",
            //         value: 2
            //     },
            //     {
            //         label: "Margin Release",
            //         value: 3
            //     }
            // ],
            rules: [
                {
                    required: true,
                    message: "Field is Required"
                },
            ]
        },
        request_raised_by: {
            className: "form-field mr-10 mb-0",
            type: INPUT_TYPES.OBJECT_SELECT,
            showSearch: true,
            onSearch: salesPerson,
            getOptionsOnFocus: salesPerson,
            label: "Request Raised By",
            category: 1,
            labelProp: "full_name",
            filterOption: true,
            rules: [
                {
                    required: true,
                    message: "Field is Required"
                },
            ]
        },
        ho_remarks: {
            key: "ho_remarks",
            label: "HO Remarks",
            dataIndex: "ho_remarks",
            className: "form-field mr-10 mb-0",
            type: INPUT_TYPES.TEXT,
            labelProp: "name",
            rules: [
                {
                    required: true,
                    message: "Field is Required"
                },
            ]
        },
        key_approver: {
            className: "form-field mr-10 mb-0",
            type: INPUT_TYPES.OBJECT_SELECT,
            showSearch: true,
            onSearch: vpSalesManagers,
            getOptionsOnFocus: vpSalesManagers,
            label: "Key Approver",
            category: 1,
            filterOption: true,
            labelProp: "full_name",
            rules: [
                {
                    required: true,
                    message: "Field is Required"
                },
            ]
        },
        requested_on: {
            key: "requested_on",
            label: "Request raised on",
            dataIndex: "requested_on",
            type: INPUT_TYPES.DATE,
            disabledDate: current => {
                return current && current > moment();
            },
            placeholder: "yyyy-mm-dd",
            className: "form-field mr-10 mb-0",
            rules: [
                {
                    required: true,
                    message: "Field is Required"
                },
            ]
        },
        approval_document: {
            className: "form-field fb-20",
            dataIndex: "approval_document",
            label: "Please Upload Approval email",
            btnLabel: "Upload File",
            showUploadList: false,
            type: INPUT_TYPES.FILE,
            accept: ".eml, .pdf",
            rules: [
                {
                    required: true,
                    message: "Field is Required"
                },
            ]
        },
    });

    componentDidMount() {
    }


    closeModal = () => {
        this.props.closeModal()
    }

    fetchVpSalesManagers = async search => {
        return CompanyService.getVPSMList(search);
    }

    fetchSalesPerson = async search => {
        return CompanyService.getUsersList("");
    }
    onSubmit=()=>{
       
        this.props.form.validateFields((err, values) => {
            if(!err){
                this.setState({
                    addDeviationLoader: true
                })
                let objectData = this.props.form.getFieldsValue();
                const formValues = {...objectData , request_raised_by : objectData.request_raised_by.id , key_approver : objectData.key_approver.id}
                const formData = new FormData();
                for (const key in formValues) {
                    if(key != "requested_on" && key != "deviation_raised_for"){
                        formData.append(key, formValues[key]);
                    }
                }
                formData.append("company" , this.props.companyId);
                formData.append("requested_on", moment(formValues['requested_on']).format("YYYY-MM-DD"));
                CompanyService.addDbDeviation(formData)
                .then((resp) => {
                    this.props.fetchDbDeviations();
                    message.success("Deviation Approved Successfully");
                    this.closeModal()
                    this.setState({
                        addDeviationLoader: false
                    })
                })
                .catch(err => {
                    this.setState({
                        addDeviationLoader: false
                    })
                }) 
            }
          
        });       
    }

    render() {
        return (
            <Drawer
                title={"DB Level Deviations"}
                closable
                visible={this.props.visible}
                onClose={this.closeModal}
                placement={"right"}
                width={"60vw"}
                footer={null}
            >
                <Row>
                    <Col span={24}>
                        <Form>
                            <div className={"form-row align-items-center"}>
                                <React.Fragment>
                                    {this.formFields(this.fetchVpSalesManagers, this.fetchSalesPerson).map((field, fieldName) => {
                                        if (fieldName === "sales_manager_user_id") {
                                            field.options = this.state.sales_manager_users && this.state.sales_manager_users.length ? new List(this.state.sales_manager_users.map((_) => ({
                                                label: _.full_name,
                                                value: _.id
                                            }))) : new List([]);
                                        }
                                        if(fieldName == "deviation_raised_for"){
                                            field.placeholder = this.props.companyName;
                                        }
                                        return<Col className="mt-10" span="12"> {this.fieldGenerator(
                                            fieldName,
                                            field,
                                            this.getValidateStatus(fieldName)
                                        )()}</Col>;
                                        
                                    })
                                        .toList()}
                                </React.Fragment>
                            </div>
                            <div className="d-flex justify-content-flex-end">

                        <FormItem className={"mr-5"}>
                            <Button loading={this.state.addDeviationLoader} onClick={() => this.onSubmit()} shape="round"  key="save" type="primary">Approve</Button>
                        </FormItem>
                    </div>
                        </Form>
                    </Col>
                </Row>
            </Drawer>
        );
    }
}

AddDeviationModal.propTypes = {
    stageId: PropTypes.string,
    notesCreating: PropTypes.bool,
    visible: PropTypes.bool,
    userId: PropTypes.string
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return (
            values &&
            values
                .toSeq()
                .toMap()
                .map((value, key) => {
                    if (key === "requested_on") {
                        return Form.createFormField({
                            value: value && moment(value)
                        });
                    }
                    return Form.createFormField({
                        value
                    });
                })
                .toJS()
        );
    }
})(AddDeviationModal);